import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from "@mui/material/Stack";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    width: 400,
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

interface CreateUserModalProps {
    show: boolean;
    handleClose(): void;
    reFetch(): void;
}

const CreateUserModal = (props: CreateUserModalProps): React.ReactElement => {
    const [userName, setUserName] = React.useState<string>("");
    const [password, setPassword] = React.useState<string>("");

    const createUser = async(): Promise<void> => {
        const result = await fetch(`/api/v1/Users`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("echo-si-jwt")}`
            },
            body: JSON.stringify({
                userName,
                password
            })
        });

        if(result.status == 200) {
            setUserName("");
            setPassword("");
            props.handleClose();
            props.reFetch();
            return;
        }
        else return;
    };

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={props.show}
                onClose={props.handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={props.show}>
                    <Box sx={style}>
                        <Stack
                            onSubmit={(e: any) => {
                                e.preventDefault();
                                createUser().then();
                                return false;
                            }}
                            component="form"
                            noValidate
                            autoComplete="off"
                            spacing={3}
                        >
                            <TextField id="outlined-basic" required value={userName} onChange={e => setUserName(e.currentTarget.value)} label="Username" variant="outlined" />
                            <TextField id="outlined-basic" required value={password} onChange={e => setPassword(e.currentTarget.value)} label="Password" variant="outlined" />
                            <Button variant="contained" type="submit">Confirm creation</Button>
                        </Stack>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
};

export default CreateUserModal;